module.exports = __webpack_public_path__ + "static/media/fs_truman-regular-webfont.19593dc8.woff";